export const paymentFilter = (year, month, row) => {
    const {year: yearName,  monthName, late, lateMonthName, lateYear} = row;
    const fieldToFilter = (late? `${lateMonthName}, ${lateYear}` : `${monthName}, ${yearName}`)
    const [monthVal, yearVal] = fieldToFilter?.split(', ') || [];
    if (year.length && !year.includes(yearVal)) return false;
    return !(month.length && !month.includes(monthVal));
}